var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import { GalleryMenu } from '.';
import { getGalleryMenuProps } from '../../../../../utils/contentful/getGalleryMenuProps';
import { DELAYS } from '../../../fadeInAnimation';
import { GalleryLinkList, } from './GalleryLinkList';
export var ContentfulGalleryMenu = function (_a) {
    var _b;
    var activeItem = _a.activeItem, _c = _a.onNavigate, onNavigate = _c === void 0 ? function () { } : _c;
    var _d = getGalleryMenuProps(activeItem), column1Props = _d.column1Props, column2Props = _d.column2Props;
    return (React.createElement(GalleryMenu, { column1: React.createElement(GalleryLinkList, __assign({}, column1Props, { size: "large", useIconOnMobile: true, delay: DELAYS[1], onNavigate: onNavigate })), column2: React.createElement(GalleryLinkList, __assign({}, column2Props, { size: "medium", delay: DELAYS[2], onNavigate: onNavigate })), defaultActiveLink: (_b = column1Props === null || column1Props === void 0 ? void 0 : column1Props.links) === null || _b === void 0 ? void 0 : _b[0], allLinks: __spreadArray(__spreadArray([], column1Props === null || column1Props === void 0 ? void 0 : column1Props.links, true), column2Props === null || column2Props === void 0 ? void 0 : column2Props.links, true) }));
};
